<template>
  <div class="login-container">
    <div class="login-left">
      <div class="left-content">
        <div class="features-section">
          <div
            class="feature-item"
            v-for="(feature, index) in features"
            :key="index"
          >
            <div class="feature-icon">
              <i :class="feature.icon"></i>
            </div>
            <div class="feature-text">
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.desc }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="decoration-circles">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
        <div class="circle circle-3"></div>
      </div>
    </div>

    <div class="login-right">
      <div class="login-box">
        <div class="brand-section">
          <img src="@/assets/imgs/tzlogo.png" alt="Logo" class="brand-logo" />
          <h1 class="brand-title">检测检查数据仪表盘</h1>
          <p class="brand-subtitle">Inspection & Detection Data Dashboard</p>
        </div>

        <tz-form
          :formConfig="formConfig"
          :formBtns="formBtns"
          @submit="submitFn"
        ></tz-form>

        <div class="login-footer">
          <p>© 2023 天宙科技 数据仪表盘系统</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetUrlValueByParamName, SHA256 } from '@/utils/util'
import { login } from '@/utils/brequest'

export default {
  data() {
    return {
      features: [
        {
          icon: 'el-icon-data-analysis',
          title: '实时数据分析',
          desc: '多维度数据可视化展示'
        },
        {
          icon: 'el-icon-s-marketing',
          title: '智能统计报表',
          desc: '自动生成统计报告'
        }
      ],
      formConfig: [
        {
          placeholder: '请输入账号',
          icon: 'el-icon-s-custom',
          field: 'loginName',
          type: 'text',
          rules: [{ required: true, message: '账号必填', trigger: 'blur' }]
        },
        {
          placeholder: '请输入密码',
          icon: 'el-icon-lock',
          field: 'password',
          type: 'password',
          showPwd: true,
          rules: [{ required: true, message: '密码必填', trigger: 'blur' }]
        }
      ],
      formBtns: [
        {
          content: '登录',
          type: 'primary',
          width: '100%'
        },
        {
          content: '重置',
          type: '',
          width: '100%'
        }
      ]
    }
  },
  methods: {
    async submitFn(formData) {
      let ret = await login({
        loginName: formData.loginName,
        password: SHA256(formData.password)
      })
      if (ret) {
        let url = '/'
        let params = location.href.split('?')[1]
        if (params) {
          let str = GetUrlValueByParamName('redirectUrl', params)
          if (str) {
            url = decodeURIComponent(str)
          }
        }
        this.$router.push(url)
      } else {
        console.error('login failed')
        this.$message({
          message: '登录失败',
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-left {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('../../assets/imgs/dete.jpg') center/cover no-repeat;
    opacity: 0.15;
  }
}

.left-content {
  position: relative;
  z-index: 2;
  max-width: 600px;
  color: #fff;
}

.brand-section {
  text-align: center;
  margin-bottom: 30px;

  .brand-logo {
    width: 60px;
    height: 60px;
    margin-bottom: 15px;
  }

  .brand-title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 8px;
    color: #333;
  }

  .brand-subtitle {
    font-size: 12px;
    color: #999;
    letter-spacing: 1px;
  }
}

.features-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
  }

  .feature-icon {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    font-size: 24px;
  }

  .feature-text {
    h3 {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 4px;
    }

    p {
      font-size: 12px;
      opacity: 0.8;
    }
  }
}

.decoration-circles {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;

  .circle {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
  }

  .circle-1 {
    width: 300px;
    height: 300px;
    top: -100px;
    left: -100px;
  }

  .circle-2 {
    width: 200px;
    height: 200px;
    bottom: 50px;
    right: 100px;
  }

  .circle-3 {
    width: 150px;
    height: 150px;
    top: 50%;
    left: 10%;
  }
}

.login-right {
  width: 480px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  box-shadow: -10px 0 40px rgba(0, 0, 0, 0.1);
}

.login-box {
  width: 100%;
  max-width: 360px;
  padding: 40px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;

  h2 {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
  }

  p {
    font-size: 14px;
    color: #999;
  }
}

.login-footer {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;

  p {
    font-size: 12px;
    color: #999;
  }
}

::v-deep .tz-form {
  .el-input {
    height: 48px;

    .el-input__inner {
      height: 48px;
      line-height: 48px;
      font-size: 14px;
      padding-left: 45px;
    }

    .el-input__prefix {
      left: 15px;
      font-size: 18px;
      color: #999;
    }
  }

  .el-form-item {
    margin-bottom: 24px;
  }

  .form-btns {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 30px;

    .el-button {
      height: 48px;
      font-size: 16px;
      font-weight: 500;
      border-radius: 8px;

      &.el-button--primary {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .login-left {
    display: none;
  }

  .login-right {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .login-box {
    padding: 30px 20px;
  }

  .login-header h2 {
    font-size: 24px;
  }
}
</style>
